<template>
  <div class="d-flex flex-wrap mx-n1 px-4 py-4" style="background-color: #F5F5F5;">
      <div class="d-flex align-center wrapper mx-1 my-1" v-if="!monthDisabled">
          <month-picker width="7rem" v-model="month" label="Tháng" outlined dense></month-picker>
      </div>
      <div class="d-flex align-center wrapper" v-if="fromTo">
        <v-text-field type="date" class="mx-1 my-1 flex-grow-0 flex-shrink-1 rounded-lg" dense label="Từ ngày" 
          :value="dateFrom" @change="changeDateFrom"
          outlined hide-details style="max-width: 200px;"></v-text-field>
        <v-text-field type="date" class="mx-1 my-1 flex-grow-0 flex-shrink-1 rounded-lg" dense label="Đến ngày" 
          :value="dateTo" @change="changeDateTo"
          outlined hide-details style="max-width: 200px;"></v-text-field>
      </div>
      <div v-for="item in filters.slice(0, 4)" :key="item.name">
        <v-text-field v-if="item.type=='text'" :label="item.label" outlined :type="item?.isFieldDate??''" color="green"
        v-model="item.value" hide-details dense persistent-placeholder placeholder=""
        class="mx-1 my-1 flex-grow-0 flex-shrink-1 rounded-lg" style="background-color: white;"
        ></v-text-field>
        <v-select v-if="item.type=='select'" :label="item.label" dense v-model="item.value" outlined hide-details persistent-placeholder placeholder=""
        :items="item.selectItems" class="mx-1 my-1 flex-shrink-1 rounded-lg" style="max-width: 200px;background-color: white;" clearable></v-select>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center wrapper mx-1 my-1">
        <v-btn @click="$emit('refresh')" outlined color="green lighten-3" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
          <v-icon color="green darken-4">mdi-refresh</v-icon></v-btn>
      </div>
      <div class="d-flex align-center wrapper mx-1 my-1">
        <v-btn dark @click="expand=!expand" color="green darken-4" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;">
          <v-icon color="green lighten-5">mdi-tune</v-icon></v-btn>
      </div>
      <!-- <div class="d-flex align-center wrapper mx-1 my-1">
        <v-btn color="green darken-4" class="rounded-lg" block style="width: 40px !important; height: 40px; padding: 0px;" dark><v-icon >mdi-magnify</v-icon></v-btn>
      </div> -->
      
    <v-expand-transition >
      <v-sheet style="width: 100%;" v-show="expand">
      
        <div class="d-flex flex-wrap" style="background-color: #F5F5F5; width: 100%;">
          <v-divider class="my-4" style="width: 100%;"></v-divider>
        </div>
        <div class="d-flex flex-wrap" style="background-color: #F5F5F5; width: 100%;">
          <div v-for="item in filters.slice(4)" :key="item.name" >
            <v-text-field v-if="item.type=='text'" :label="item.label" outlined :type="item?.isFieldDate??''" 
            v-model="item.value" hide-details dense persistent-placeholder placeholder=""
            class="mx-1 my-1 flex-grow-0 flex-shrink-1 rounded-lg" style="background-color: white;"
            ></v-text-field>
            <v-select v-if="item.type=='select'" :label="item.label" dense v-model="item.value" outlined hide-details persistent-placeholder placeholder=""
            :items="item.selectItems" class="mx-1 my-1 flex-shrink-1 rounded-lg" style="max-width: 200px;background-color: white;" clearable></v-select>
          </div>
        </div>
      </v-sheet>
    </v-expand-transition>
  </div>

</template>

<script>
export default {
  name: "IndexFilter",
  props: {
    filters: {
      type: Array // {name: '', type: 'text,autocomplete,select, date', selectItems:[], label: '', isFieldDate}
    },
    month: {
      type: String
    },
    monthDisabled: {
      type: Boolean,
      default: false
    },
    fromTo: {
      type: Boolean,
      default: false
    },
    dateFrom: {
      type: [Date,String],
      default: null
    },
    dateTo: {
      type: [Date,String],
      default: null
    }

  },
  watch: {
    month(value) {
      this.$emit('changeMonth', value)
    },
    // dateFrom(value) {
    // },
    // dateTo(value) {
    //   this.$emit('dateToChange', value)
    // },
  },
  data() {
    return {
      expand: false
    }
  },
  methods: {
    changeDateFrom(value) {
      this.$emit('changeDateFrom', value)
    },
    changeDateTo(value) {
      this.$emit('changeDateTo', value)
    }
  }
}
</script>